module.exports = __webpack_public_path__ + "img/Sleep.147e38e8.png";